import React, { useCallback } from 'react';
import { Box, HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import RouteKey from '../../../routes/key';
import SelectConditionContent from '../../../modules/accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';

const {
  coordinatorRoot,
  coordinatorImportantNotes,
  coordinatorAccessArrangementsRequest,
  coordinatorSummary,
  coordinatorAmendAccessArrangements,
} = RouteKey['access-arrangement'].child;
const { accessArrangement } = RouteKey.child;

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-5%',
    marginTop: theme.spacing(9),
  },
}));

interface SelectConditionCoordinatorProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title: string;
  amendment?: boolean;
}

const SelectConditionCoordinator = ({
  routeSteps,
  activeStep,
  title,
  amendment = false,
}: SelectConditionCoordinatorProps) => {
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();
  const { t } = useTranslation();
  const { classes } = useStyles();

  const handleBack = () => {
    if (amendment) {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorSummary.route}/${uuid}`
      );
    } else {
      localStorage.setItem('uuid', uuid);
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorImportantNotes.route}`
      );
    }
  };

  const onSuccess = useCallback(() => {
    if (amendment) {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorAmendAccessArrangements.route}/${uuid}`
      );
    } else {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorAccessArrangementsRequest.route}/${uuid}`
      );
    }
  }, [history, uuid, amendment]);

  const candidateNameNewApplication =
    localStorage.getItem(`candidateNameNewApplication: ${uuid}`) || '';
  const candidateNameContinueApplication =
    localStorage.getItem(`candidateNameContinueApplication: ${uuid}`) || '';

  const candidateNameAmendmentApplication =
    localStorage.getItem(`candidateNameAmendmentApplication: ${uuid}`) || '';

  return (
    <>
      <TitleHeader title={title} />

      <HeaderTemplate>
        <KeyValue
          keyText={t('accessArrangement->>CoordinatorSelectCandidate.CandidateName')}
          valueText={
            amendment
              ? candidateNameAmendmentApplication
              : candidateNameNewApplication || candidateNameContinueApplication
          }
        />
        <Box className={classes.stepper}>
          <Stepper activeStep={activeStep} steps={routeSteps} />
        </Box>
      </HeaderTemplate>
      <SelectConditionContent handleBack={handleBack} onSuccess={onSuccess} amendment={amendment} />
    </>
  );
};
export default SelectConditionCoordinator;
